import type { ISessionRepository } from '../repositories/ISessionRepository.js';

interface Deps { sessionRepository: ISessionRepository; }

export function createDeleteSessionUseCase({ sessionRepository }: Deps) {
  return async function deleteSession(id: string): Promise<void> {
    return sessionRepository.delete(id);
  };
}
